"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BREAKPOINT_CATEGORY_KEY = 'base';
exports.BREAKPOINT_COMPONENT_KEY = 'breakpoint';